import Swal from "sweetalert2";

export function resolvePosicaoPneuId(veiculoSensor: any): number | null {
  if (!veiculoSensor) {
    return null;
  }
  if (veiculoSensor.pneu?.posicaoPneu?.id != null) {
    return veiculoSensor.pneu.posicaoPneu.id;
  }
  if (veiculoSensor.posicaoPneu?.id != null) {
    return veiculoSensor.posicaoPneu.id;
  }
  return null;
}

export function findVeiculoSensorByPosicaoId(
  veiculoSensores: any[],
  posicaoId: number
): any | null {
  if (!veiculoSensores?.length) {
    return null;
  }

  const matches = veiculoSensores.filter(
    (item) => resolvePosicaoPneuId(item) === posicaoId
  );

  if (!matches.length) {
    return null;
  }

  return matches.reduce((best, current) => {
    if (!best) {
      return current;
    }
    if (current.sensor != null && best.sensor == null) {
      return current;
    }
    if (best.sensor != null && current.sensor == null) {
      return best;
    }
    return (current.id ?? 0) > (best.id ?? 0) ? current : best;
  }, null);
}

export function appendSensorToCombo(combo: any[], sensor: any): void {
  if (sensor && !combo.some((item) => item.id === sensor.id)) {
    combo.push(sensor);
  }
}

function hasTpmsValue(value: unknown): boolean {
  return value != null && String(value).trim() !== "";
}

function hasSensorSelected(row: any): boolean {
  return row?.cdSensor != null && String(row.cdSensor).trim() !== "";
}

export function isSensorRowComplete(row: any): boolean {
  if (!hasSensorSelected(row)) {
    return true;
  }

  return (
    hasTpmsValue(row.nrPressaoMinima) &&
    hasTpmsValue(row.nrPressaoMaxima) &&
    hasTpmsValue(row.nrTemperaturaMaxima)
  );
}

export function findIncompleteSensorRows(rows: any[]): string[] {
  if (!rows?.length) {
    return [];
  }

  return rows
    .filter((row) => hasSensorSelected(row) && !isSensorRowComplete(row))
    .map((row) => row.cdPosicaoPneu || "Posição do pneu");
}

export async function alertIncompleteTpmsRows(
  positions: string[]
): Promise<void> {
  const lista = positions.map((posicao) => `<li>${posicao}</li>`).join("");

  await Swal.fire({
    icon: "warning",
    title: "Campos obrigatórios não preenchidos",
    html:
      "Informe pressão mínima, pressão máxima e temperatura máxima para vincular sensores em:<ul style=\"text-align:left;margin-top:8px;\">" +
      lista +
      "</ul>",
    showCloseButton: false,
    reverseButtons: true,
    showConfirmButton: true,
    confirmButtonText: "OK",
    focusConfirm: false,
  });
}

export function markTpmsFormsTouched(forms: Array<{ markAllAsTouched: () => void }>): void {
  forms.forEach((form) => form.markAllAsTouched());
}
